// extracted by mini-css-extract-plugin
export default {"video":"_17nlLrtIunm7rAhHYlFLcI"};